import _WidgetBaseSP from 'more/_WidgetBaseSP';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './Stage.html?raw';
import { TiEntities, TiInterfaces } from "../TiTypes";
import GenericEntityView from '../../../moreCore/UI/EntityBased/EntityView/GenericEntityView';

class TiStage extends compose(_WidgetBaseSP) {
    templateString: any = template;

    private slotInfoContainer: HTMLElement;
    private topContainer: HTMLElement;
    private iconNode: HTMLElement;
    private statusIconContainer: HTMLElement;
    private titleNode: HTMLElement;
    private descriptionNode: HTMLElement;

    private entityView: MdsLax<InstanceType<typeof GenericEntityView>>;

    private sectionExtendedInfo: HTMLElement;

    private entity: TiEntities.StageEntity;

    private config: TiInterfaces.TiStageConfig = {
        
    };

    setData(entity: TiEntities.StageEntity,
        config?: TiInterfaces.TiStageConfig) {

        if (config) this.setConfig(config);

        this.entity = entity;

        this.drawData();        
    }

    setConfig(config: TiInterfaces.TiStageConfig) {
        this.config = config;

       

        if (this.entity) {
            this.drawData();
        }
    }


    private drawData() {

        let stage = this.entity;
        let container = this.domNode;

        //this.UiModder.domClass.toggle(this.domNode, "cancelled", stage.ref_status_stage);

        let view = new GenericEntityView();

        view.setup(this.entity.ID,
            this.entity.Classname,
            this.entity.displayname,
            "displayname",
            this.sectionExtendedInfo);

        this.UiModder.domClass.add(container, stage.Classname);

        let topRow = this.topContainer;
        this.UiModder.domConstruct.empty(this.titleNode);
        this.UiModder.domAttr.set(this.titleNode, "innerHTML", this.dateToString(stage.date_start, "dd.MM.yyyy HH:mm"));
        //this.UiModder.domAttr.set(this.descriptionNode, "innerHTML", stage.ref_vt_good.order_number);

        if (stage.ref_transport_type?.web_icon_class) {
            let icon = this.createFontawesomeIcon(stage.ref_transport_type.web_icon_class);
            this.UiModder.domConstruct.place(icon, this.iconNode, "only");
            this.UiModder.domClass.add(icon, "paddingY paddingSmallRight");
        }        
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.RequestManager.handleAs = "jsonWithDate";
    }

    destroy(): void {
        localStorage.removeItem("Ti_routeSectionsStatus");
        super.destroy.apply(this, arguments as any);
    }
    startup() {
        super.startup.apply(this, arguments as any);
    }

}

export default mdsWidget(TiStage);